import analytics, { events } from '../../../shared/analytics';
import UiElement from '../../../shared/ui-element/ui-element';

import './special-offer-banner.scss';

class SpecialOfferBanner extends UiElement {
  ui = {
    banner: '.js-special-offer-banner',
  };

  events = {
    'click @ui.banner': 'handleBannerClick',
  };

  handleBannerClick() {
    analytics.trackEvent({
      ...events.SPECIAL_OFFER_BANNER_CLICK,
      eventLabel: 'Top',
    });
  }
}

export default SpecialOfferBanner;
